import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { productAdderStepState } from '@src/features/product';
import styled, { css } from 'styled-components';
import { device } from '@src/common/breakpoints';
import React, { FC, memo, ReactNode } from 'react';
import { Box } from '@planne-software/uni/mui/material';
import usePackageIdParam from '@src/hooks/usePackageIdParam';

export const AdderContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const widgetId = useWidgetId();
  const { currentStep } = useAppSelector(productAdderStepState(widgetId));
  const packageId = usePackageIdParam();

  return (
    <StyledAdderContainer $isSeatMap={currentStep === 'seat_map'} $isPackage={Boolean(packageId)}>
      {children}
    </StyledAdderContainer>
  );
};

const StyledAdderContainer = styled(Box)<{ $isSeatMap: boolean; $isPackage: boolean }>`
  margin: auto;
  width: 100%;

  max-height: fit-content;

  box-sizing: border-box;
  overflow: hidden;

  transition: max-width 0.3s ease-in-out;

  ${device.smallTablet} {
    margin: 50px auto;
  }

  ${({ $isPackage, $isSeatMap }) =>
    $isPackage
      ? css`
          max-width: 100%;

          @media (min-width: 600px) {
            max-width: ${$isSeatMap ? '758px' : '627px'};
          }

          @media (min-width: 900px) {
            max-width: ${$isSeatMap ? '1034px' : '903px'};
          }
        `
      : css`
          max-width: ${$isSeatMap ? '1024px' : '627px'};
        `}
`;

export default memo(AdderContainer);
